import { ServiceTypes } from 'constants/ServiceTypes';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import WizardStore from 'stores/WizardStore';
import styled from 'styled-components';
import { darkgrey } from 'styles/Colors';
import WizardSteps from './components/Wizard/WizardSteps';

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: Oswald;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 24px;
  margin-bottom: 24px;
`;

const Title = styled.h1`
  color: ${darkgrey};
  text-align: center;
  font-family: Oswald;
  font-size: 25px;
  font-weight: 500;
  line-height: 35px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
`;

const Header: React.FC = observer(() => {
  const wizardStore = useInjection<WizardStore>(ServiceTypes.WizardStore);

  const getHeaderLabel = (): JSX.Element | null => {
    switch (wizardStore.currentStep) {
      case WizardSteps.Introduction:
      case WizardSteps.CleanHomeplate:
      case WizardSteps.CorrectPitching:
        return <Title data-test='calibration-data-capture-title'>Data capture preparation</Title>;
      case WizardSteps.DataCapture:
        return <Title data-test='ongoing-data-capture-title'>Capturing calibration data</Title>;
      default:
        return null;
    }
  };

  return <HeaderContainer>{getHeaderLabel()}</HeaderContainer>;
});

export default Header;
